import { render, staticRenderFns } from "./SupplierOrders.vue?vue&type=template&id=245eaade&scoped=true&"
import script from "./SupplierOrders.vue?vue&type=script&lang=js&"
export * from "./SupplierOrders.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrders.vue?vue&type=style&index=0&id=245eaade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245eaade",
  null
  
)

export default component.exports